<template>
  <div>
    <div class="title"><span v-t="'editingContainer.copyModalTitle'" /></div>
    <div class="subheading"><span v-t="'editingContainer.copyModalSubtitle'" /></div>
  </div>
</template>

<script>
export default {
  name: 'CopyProviderModalTitle',

};
</script>
